import gsap from "gsap";

import { ScrollTrigger } from "gsap/all";
import { useEffect } from "react";

import ourTeam from "../../../assets/our-team-img.png";
import jobinImg from "../../../assets/jobin-img.png";

gsap.registerPlugin(ScrollTrigger);
export default function OurTeam() {
  useEffect(() => {
    const teamItems = document.querySelectorAll(".our-team-single");

    teamItems.forEach((item, index) => {
      const image = item.querySelector("img");
      if (!image) return;

      const rotationValue = index % 2 === 0 ? -7 : 7;

      gsap.to(image, {
        rotation: rotationValue,
        ease: "none",
        scrollTrigger: {
          trigger: item,
          start: "top 80%",
          end: "bottom 20%",
          scrub: 1,
          // markers: true,
        },
      });
    });
  }, []);

  return (
    <>
      <section id="our_team">
        <div className="container">
          <div className="our-team-wrapper">
            <div className="our-team-single our-team-single-1">
              <h3 className="anim-text">Jolene Paterson</h3>
              <span className="anim-text">Founder</span>
              <p className="anim-text">
                Jolene is SMPL SOL’s calm powerhouse: 20 years a growth
                strategist, lifelong communications nerd, and the kind of
                creative who brings sunshine (and clarity) into every room she
                enters.
              </p>
              <img src={ourTeam} alt="our team" />
            </div>
            <div className="our-team-single our-team-single-2">
              <img src={jobinImg} alt="our team" />
              <h3 className="anim-text">Jobin Raju</h3>
              <span className="anim-text">Art Director</span>
              <p className="anim-text">
                Jobin is an accomplished art director known for blending
                creativity with precision. His artistic sensibility and
                collaborative spirit make him a driving force behind compelling
                visual storytelling.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
